import {
	PUBLIC_GOOGLE_ADS_CONVERSION_ID,
	PUBLIC_GOOGLE_ADS_CONVERSION_LABEL_RESERVATION_COMPLETED
} from '$env/static/public';
import Log from './log';
import type { Stripe } from 'stripe';
import { addressOfSession } from './tracking/utils';
import { getTrackingAmounts } from './stripe.utils';

// TODO: Do we really need to track GA events if we forward the Segment events?
export function trackGA<Data extends Record<string, unknown>>(
	name: string,
	data: Data = {} as Data
) {
	try {
		window.gtag('event', name, data);
	} catch (e) {
		Log.exception(e);
	}
}

interface GAEnhancedUserData extends Record<string, unknown> {
	email?: string;
	phone_number?: string;
	address?: Stripe.Address;
}

function trackGAUserData(data: GAEnhancedUserData) {
	try {
		window.gtag('set', 'user_data', data);
	} catch (e) {
		Log.exception(e);
	}
}

interface GAConversionPayload {
	value?: number;
	transaction_id?: string;
	item_id?: string;
}

function trackGAConversion(label: string, data: GAConversionPayload = {}) {
	const { value = 0.0, transaction_id, item_id } = data;

	trackGA('conversion', {
		send_to: `${PUBLIC_GOOGLE_ADS_CONVERSION_ID}/${label}`,
		value,
		currency: 'USD',
		transaction_id,
		item_id
	});
}

export function finalizeGA(session: Stripe.Checkout.Session) {
	if (session.customer_details) {
		trackGAUserData({
			email: session.customer_details.email ?? '',
			phone_number: session.customer_details.phone ?? '',
			address: addressOfSession(session)
		});
	}

	trackGAConversion(PUBLIC_GOOGLE_ADS_CONVERSION_LABEL_RESERVATION_COMPLETED, {
		value: getTrackingAmounts(session).dollars.subtotalAfterDiscountsAndBeforeTaxes,
		item_id: session.line_items?.data?.[0].id,
		transaction_id: session.id
	});
}
